import { Badge, Box } from "@chakra-ui/react";

import { LinearCleanupIssueDetails } from "@reflag/shared/featureAPI";

export function LinearIssueStateBadge({
  state,
}: {
  state: LinearCleanupIssueDetails["state"];
}) {
  return (
    <Badge alignItems="center" display="inline-flex" gap={1} flexShrink={0}>
      {state && <Box bg={state.color} borderRadius="full" boxSize="6px" />}
      {state?.name ?? "Status unavailable"}
    </Badge>
  );
}
